import { connect } from 'react-redux'
import DriverViewSessionHistoryOld from '../../components/drivers/DriverViewSessionHistoryOld'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: { operatorId: string }) {
  return {
    operatorId: ownProps.operatorId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverViewSessionHistoryOld)



// WEBPACK FOOTER //
// ./src/containers/drivers/DriverViewSessionHistoryOld.ts